enum SubscriptionType {
  None = "None",
  Survey = "Survey", // TO Remove
  Account = "Account",
  MaintenanceCompany = "MaintenanceCompany",
  ServiceProvider = "ServiceProvider",
}

export default SubscriptionType;
